import type { ComponentProps, PropsWithChildren } from 'react'
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@cocoonspace/ui/components/popover'
import { cn } from '@cocoonspace/ui/lib/utils'
import { CircleHelpIcon } from 'lucide-react'

export const InfoPopover = ({
	children,
	side = 'bottom',
	align = 'start',
	sideOffset = 5,
	classNames,
}: PropsWithChildren<
	Pick<
		ComponentProps<typeof PopoverContent>,
		'side' | 'align' | 'sideOffset'
	> & {
		classNames?: string
	}
>) => (
	<Popover>
		<PopoverTrigger asChild>
			<button
				className={cn('text-primary group text-base', classNames)}
				type='button'
			>
				<CircleHelpIcon size={16} />
			</button>
		</PopoverTrigger>

		<PopoverContent
			align={align}
			className='max-w-[320px] border px-2 py-1 text-sm'
			side={side}
			sideOffset={sideOffset}
		>
			{children}
		</PopoverContent>
	</Popover>
)
